import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setRestaurant } from "../slices/session.slice";
import { restaurantApi } from "../apis/restaurant.api";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: restaurantApi.endpoints.updateStatus.matchFulfilled,
  effect: async (action, listenerApi) => {
    const updatedRestaurant = action.payload;
    listenerApi.dispatch(setRestaurant(updatedRestaurant));
  },
});
